import { Box, Typography } from "@mui/material";

interface HelpTextProps {
  text: string;
  spanText: string;
  valueColor?: string;
}

export function HelpText({ text, spanText, valueColor }: HelpTextProps) {
  return (
    <Box
      role="textbox"
      sx={(theme) => ({
        lineHeight: theme.typography.body1.lineHeight,
        width: "100%",
        padding: theme.spacing(1, 2),
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.spacing(1),
        fontSize: {
          xs: theme.typography.subtitle1.fontSize,
          md: theme.typography.body2.fontSize,
        },
      })}>
      {text}
      <Box
        sx={(theme) => ({
          paddingLeft: theme.spacing(2),
          color: valueColor ?? theme.palette.grey[300],
          fontSize: {
            xs: theme.typography.body2.fontSize,
            md: theme.typography.body1.fontSize,
          },
        })}
        component={(props) => (
          <Typography component="span" variant="body1" {...props} />
        )}>
        {spanText}
      </Box>
    </Box>
  );
}
